import React from 'react';
import cl from 'classnames';
import { HexToRGB } from '@/utils/utils';
import { openConfiguredLink } from '@/utils/navigation';
import { Clickable } from '@/components';
import styles from './index.less';

function QuickRedemption({
  visible,
  showTitle,
  title,
  showMore,
  moreName,
  moreLink,
  pictures,
  titleFontSize,
  titleFontColor,
  titleFontColorOpacity,
  isTitleFontBold,
  isTitleFontItalic,
  staticTitleFontSize,
  staticTitleFontColor,
  staticTitleFontColorOpacity,
  isStaticTitleFontBold,
  isStaticTitleFontItalic,
  hasBg,
  bgType,
  bgColor,
  bgColorOpacity,
  bgImg,
  topMargin,
}) {
  const bgStyle = {
    marginTop: `${Number(topMargin) / 100}rem`,
    backgroundColor:
      hasBg === 'Y' && bgType === 'Color' ? HexToRGB(bgColor, bgColorOpacity) : 'transparent',
    backgroundImage: hasBg === 'Y' && bgType === 'Image' ? `url(${bgImg.src})` : 'initial',
    backgroundSize: '100%',
    backgroundPosition: 'top center',
    backgroundRepeat: 'no-repeat',
    borderRadius: '.16rem',
  };

  const titleStyles = {
    fontSize: `${Number(titleFontSize) / 100}rem`,
    color: HexToRGB(titleFontColor, titleFontColorOpacity),
    fontWeight: isTitleFontBold === 'Y' ? 500 : 'normal',
    fontStyle: isTitleFontItalic === 'Y' ? 'italic' : 'normal',
  };

  const moreStyles = {
    fontSize: `${Number(staticTitleFontSize) / 100}rem`,
    color: HexToRGB(staticTitleFontColor, staticTitleFontColorOpacity),
    fontWeight: isStaticTitleFontBold === 'Y' ? 500 : 'normal',
    fontStyle: isStaticTitleFontItalic === 'Y' ? 'italic' : 'normal',
  };

  return (
    <div
      className={cl(styles.carouselBox, {
        hidden: !visible,
      })}
      style={bgStyle}
    >
      <div className={cl(styles.carouselBoxHeader, styles.quickHeader)}>
        <div className={cl(styles.moreTitle, { hidden: !showTitle })} style={titleStyles}>
          {title}
        </div>
        <Clickable
          as="a"
          onClick={() => openConfiguredLink(moreLink)}
          className={cl(styles.titleMore, { hidden: !showMore || !showTitle })}
          style={moreStyles}
        >
          {moreName}
        </Clickable>
      </div>
      <div className={styles.redeemBox}>
        {(pictures || []).map((item, index) => (
          <Clickable key={index} onClick={() => openConfiguredLink(item.link)}>
            <img src={`${item.src}?_=${Date.now()}`} alt="" />
          </Clickable>
        ))}
      </div>
    </div>
  );
}

export default QuickRedemption;
